export default {
  label: {
    exportLabel: 'Descargar como',
    exportLabelType: 'Descargar como {type}',
  },
};
